module.exports = {
  id: 10,
  name: 'Skater Hops',
  categories: ['cardio', 'legs', 'balance'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'intermediate',
  skill: 'Balance',
  points: 14,
  instructions:
    'Skater Hops make you move like a skater! Stand with your feet apart, hop to the right and touch your left foot behind your right, then hop to the left and touch your right foot behind your left!',
  timedInstructions: [
    // SETUP
    {
      time: 0,
      text: 'Ready to hop like a skater? Let us build incredible balance and coordination!',
    },
    {
      time: 3,
      text: 'Stand with your feet apart, ready to hop!',
    },
    {
      time: 6,
      text: 'Keep your core engaged and stay light on your feet!',
    },
    {
      time: 9,
      text: '3, 2, 1, START! Hop to the right and touch your left foot behind!',
    },
    // SET 1 - 12 hops
    {
      time: 12,
      text: 'Perfect skater position! Feet apart, ready to move!',
    },
    {
      time: 15,
      text: 'Number 1! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 18,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 21,
      text: 'Number 2! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 24,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 27,
      text: 'Number 3! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 30,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 33,
      text: 'Number 4! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 36,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 39,
      text: 'Number 5! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 42,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 45,
      text: 'Number 6! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 48,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 51,
      text: 'Number 7! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 54,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 57,
      text: 'Number 8! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 60,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 63,
      text: 'Number 9! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 66,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 69,
      text: 'Number 10! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 72,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 75,
      text: 'Number 11! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 78,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 81,
      text: 'Number 12! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 84,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 87,
      text: 'Great job! Take a deep breath and shake out your legs.',
    },
    // REST PERIOD 1 - 20 seconds
    {
      time: 90,
      text: 'Take a deep breath in and out, you are building incredible balance!',
    },
    {
      time: 93,
      text: 'Shake out your legs and feet, get ready for round two!',
    },
    {
      time: 96,
      text: 'You are doing amazing! Ready for round two? Let us keep going!',
    },
    {
      time: 99,
      text: '3, 2, 1, START! Remember the form!',
    },
    // SET 2 - 12 hops
    {
      time: 102,
      text: 'Stand with your feet apart, ready to hop!',
    },
    {
      time: 105,
      text: 'Keep your core engaged and stay light on your feet!',
    },
    {
      time: 108,
      text: 'Perfect skater position! Hop to the right and touch your left foot behind!',
    },
    {
      time: 111,
      text: 'Number 1! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 114,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 117,
      text: 'Number 2! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 120,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 123,
      text: 'Number 3! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 126,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 129,
      text: 'Number 4! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 132,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 135,
      text: 'Number 5! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 138,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 141,
      text: 'Number 6! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 144,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 147,
      text: 'Number 7! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 150,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 153,
      text: 'Number 8! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 156,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 159,
      text: 'Number 9! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 162,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 165,
      text: 'Number 10! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 168,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 171,
      text: 'Number 11! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 174,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 177,
      text: 'Number 12! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 180,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 183,
      text: 'Great job! Take a deep breath and shake out your legs.',
    },
    // REST PERIOD 2 - 20 seconds
    {
      time: 186,
      text: 'Take a deep breath in and out, you are building incredible balance!',
    },
    {
      time: 189,
      text: 'Shake out your legs and feet, get ready for the final round!',
    },
    {
      time: 192,
      text: 'You are doing amazing! Ready for the final round? Let us finish strong!',
    },
    {
      time: 195,
      text: '3, 2, 1, START! Remember the form!',
    },
    // SET 3 - 12 hops
    {
      time: 198,
      text: 'Stand with your feet apart, ready to hop!',
    },
    {
      time: 201,
      text: 'Keep your core engaged and stay light on your feet!',
    },
    {
      time: 204,
      text: 'Perfect skater position! Hop to the right and touch your left foot behind!',
    },
    {
      time: 207,
      text: 'Number 1! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 210,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 213,
      text: 'Number 2! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 216,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 219,
      text: 'Number 3! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 222,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 225,
      text: 'Number 4! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 228,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 231,
      text: 'Number 5! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 234,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 237,
      text: 'Number 6! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 240,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 243,
      text: 'Number 7! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 246,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 249,
      text: 'Number 8! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 252,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 255,
      text: 'Number 9! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 258,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 261,
      text: 'Number 10! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 264,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 267,
      text: 'Number 11! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 270,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 273,
      text: 'Number 12! Hop to the right and touch your left foot behind your right!',
    },
    {
      time: 276,
      text: 'Hop to the left and touch your right foot behind your left!',
    },
    {
      time: 279,
      text: 'Incredible work! You are done! You just completed all three sets!',
    },
    // COMPLETION
    {
      time: 282,
      text: 'Amazing work! You did 36 skater hops and built incredible balance!',
    },
    {
      time: 285,
      text: 'You are getting super coordinated and balanced! You are a skater master!',
    },
    {
      time: 288,
      text: 'Great job, balance champion! You are building incredible skills!',
    },
  ],
};
